// import { BrowserRouter, Route } from 'react-router-dom'
import { Router, Route, BrowserRouter, Routes } from 'react-router-dom'
import Tracings from './Tracings'
import * as Sentry from '@sentry/react'
import Home from './Home'
import Login from './Login/Login'

import "./App.css"
import SingleLookup from './SingleLookup'
import SingleMpnLookup from './MpnLookup/SingleMpnLookup'
import { ThemeProvider, createTheme } from '@mui/material/styles'
// import CssBaseline from '@mui/material/CssBaseline'

const uberTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      // main: '#3f51b5',
      main: '#212121',
    },
    // secondary: {
    //   main: '#f50057',
    // },
  },
})

// import ErrorPage from '../Testing/ErrorPage'


const App = () => {

  return (
   
    <ThemeProvider theme={uberTheme}>
      
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/lookup" element={<SingleLookup />} /> */}
        <Route path="/mpnlookup" element={<SingleMpnLookup />} />
        {/* <Route path="/lookupmany" element={<Tracings />} /> */}
      </Routes>
    </BrowserRouter>
   </ThemeProvider>

  )
}

export default Sentry.withProfiler(App)